import { createContext } from 'react'

type GridOptionsContextType = {
  col: {
    mobileS?: number
    mobileM?: number
    mobileL?: number
    tablet?: number
    laptop?: number
    laptopL?: number
    desktop?: number
  }
}

export const GridOptionsContext = createContext<GridOptionsContextType>({
  col: {},
})
